module.exports = __webpack_public_path__ + "img/truck_active.538090fc.svg";